export default __webpack_public_path__ + "static/marcus-ccfe68d280c014cc7dc54066d1584f9a.jpeg";